export const SKINS = {
    standard: 'standard',
    success: 'success',
    error: 'error',
    urgent: 'urgent',
};
export const SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=constants.js.map